export default "__VITE_ASSET__eX2_9qvO__"